import type { Raster } from '@repo/warp-engine';

export interface RasterCache {
  readonly get: (key: string, url: string) => Promise<Raster>;
  readonly invalidate: (key: string) => void;
}

/** 키(사진·마스크·음영 키 또는 assetId)별 래스터 캐시. 진행 중인 로드도 공유하고, 실패한 항목은 지워 재시도할 수 있게 한다. */
export const createRasterCache = (load: (url: string) => Promise<Raster>): RasterCache => {
  const entries = new Map<string, Promise<Raster>>();
  return {
    get: (key, url) => {
      const cached = entries.get(key);
      if (cached !== undefined) return cached;
      const pending = load(url).catch((error: unknown) => {
        entries.delete(key);
        throw error;
      });
      entries.set(key, pending);
      return pending;
    },
    invalidate: (key) => {
      entries.delete(key);
    },
  };
};
